import React, { useEffect, useState } from 'react'
import Slider from "react-slick";
import LazyLoad from 'react-lazyload';
import { getSliders } from "../Service/Api";

const DEFAULT_IMAGE =
    "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/kindergarten1.jpg";

const s3_URL = "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com";

const KindergartenSlider = () => {
    const [sliders, setSliders] = useState([]);

    useEffect(() => {
        const fetchSliders = async () => {
            try {
                const data = await getSliders();

                const visibleSliders = Array.isArray(data)
                    ? data
                        .filter((item) => item.school === "Junior")
                        .filter((item) => item.visibility === false)
                        .sort((a, b) => a.position - b.position)
                    : [];

                setSliders(visibleSliders);
            } catch (error) {
                console.error("Error loading kindergarten sliders:", error);
                setSliders([]);
            }
        };

        fetchSliders();
    }, []);

    const settings = {
        autoplay: true,
        infinite: true,
        autoplaySpeed: 2000,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 0,
        arrows: false,
        adaptiveHeight: true,
    };

    return (
        <>
            <Slider {...settings}>
                {sliders.length === 0 ? (
                    <div className="carousel-item active">
                        <LazyLoad>
                            <img
                                src={DEFAULT_IMAGE}
                                className="d-block w-100"
                                alt="Nirmala School Rajkot"
                            />
                        </LazyLoad>
                    </div>
                ) : (
                    sliders.map((slider, index) => (
                        <div
                            className={`carousel-item ${index === 0 ? "active" : ""}`}
                            key={slider._id || index}
                        >
                            <LazyLoad>
                                <img
                                    src={`${s3_URL}/${slider.attachment}`}
                                    className="d-block w-100"
                                    alt={slider.title || "Nirmala School Rajkot"}
                                />
                            </LazyLoad>
                        </div>
                    ))
                )}
            </Slider>
        </>
    )
}

export default KindergartenSlider
